var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelloImg1649933913062(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 440,
    height: 742,
    viewBox: "0 0 440 742",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4697 741.395H283.072C302.689 741.395 318.591 725.465 318.591 705.813L318.591 98.249C318.591 78.5977 302.689 62.6672 283.072 62.6672H40.4697C20.8533 62.6672 4.95108 78.5977 4.95108 98.249L4.95108 705.813C4.95108 725.465 20.8533 741.395 40.4697 741.395Z",
    fill: "#EF6767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.072 62.5377H98.3757V659.018C98.4324 672.098 103.644 684.626 112.877 693.875C122.109 703.123 134.615 708.345 147.671 708.401H318.591V98.3352C318.619 93.6444 317.722 88.9943 315.949 84.6524C314.177 80.3105 311.565 76.3625 308.264 73.0355C304.963 69.7086 301.038 67.0683 296.715 65.2667C292.391 63.4651 287.755 62.5376 283.072 62.5377Z",
    fill: "#E44A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95105 267.403H3.65946C2.68891 267.403 1.7581 267.016 1.07181 266.329C0.385525 265.641 -2.71797e-05 264.709 -2.71797e-05 263.737L-2.71797e-05 226.861C-2.71797e-05 225.889 0.385525 224.956 1.07181 224.269C1.7581 223.581 2.68891 223.195 3.65946 223.195H4.95105L4.95105 267.403Z",
    fill: "#DE3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95105 396.144C3.63794 396.144 2.37862 395.622 1.45011 394.691C0.521603 393.761 -2.71797e-05 392.5 -2.71797e-05 391.184L-2.71797e-05 316.786C-2.71797e-05 315.47 0.521603 314.209 1.45011 313.279C2.37862 312.349 3.63794 311.826 4.95105 311.826V311.826L4.95105 396.144Z",
    fill: "#11111A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.66 86.9058H50.3718C38.7209 86.9058 29.2759 96.3676 29.2759 108.039V171.375C29.2759 183.047 38.7209 192.508 50.3718 192.508H113.66C125.31 192.508 134.755 183.047 134.755 171.375V108.039C134.755 96.3676 125.31 86.9058 113.66 86.9058Z",
    fill: "#11111A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.493 175.106C110.276 175.106 111.722 173.657 111.722 171.871C111.722 170.084 110.276 168.636 108.493 168.636C106.71 168.636 105.264 170.084 105.264 171.871C105.264 173.657 106.71 175.106 108.493 175.106Z",
    fill: "#08080D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0157 121.841C90.1 121.841 96.6536 115.275 96.6536 107.177C96.6536 99.0781 90.1 92.5128 82.0157 92.5128C73.9313 92.5128 67.3777 99.0781 67.3777 107.177C67.3777 115.275 73.9313 121.841 82.0157 121.841Z",
    fill: "#08080D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0157 117.312C87.6034 117.312 92.1331 112.774 92.1331 107.177C92.1331 101.579 87.6034 97.0413 82.0157 97.0413C76.428 97.0413 71.8983 101.579 71.8983 107.177C71.8983 112.774 76.428 117.312 82.0157 117.312Z",
    fill: "#1E1E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0156 112.568C84.9878 112.568 87.3972 110.154 87.3972 107.177C87.3972 104.199 84.9878 101.786 82.0156 101.786C79.0435 101.786 76.634 104.199 76.634 107.177C76.634 110.154 79.0435 112.568 82.0156 112.568Z",
    fill: "#050508"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1056 162.167H77.9256C74.8345 162.167 72.3287 164.677 72.3287 167.774V175.947C72.3287 179.043 74.8345 181.553 77.9256 181.553H86.1056C89.1967 181.553 91.7025 179.043 91.7025 175.947V167.774C91.7025 164.677 89.1967 162.167 86.1056 162.167Z",
    fill: "#21212E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5244 154.403C60.6088 154.403 67.1624 147.838 67.1624 139.739C67.1624 131.641 60.6088 125.075 52.5244 125.075C44.4401 125.075 37.8865 131.641 37.8865 139.739C37.8865 147.838 44.4401 154.403 52.5244 154.403Z",
    fill: "#08080D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5245 149.875C58.1122 149.875 62.6419 145.337 62.6419 139.739C62.6419 134.142 58.1122 129.604 52.5245 129.604C46.9368 129.604 42.407 134.142 42.407 139.739C42.407 145.337 46.9368 149.875 52.5245 149.875Z",
    fill: "#1E1E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5244 145.131C55.4966 145.131 57.906 142.717 57.906 139.739C57.906 136.762 55.4966 134.348 52.5244 134.348C49.5522 134.348 47.1428 136.762 47.1428 139.739C47.1428 142.717 49.5522 145.131 52.5244 145.131Z",
    fill: "#050508"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.493 154.403C116.577 154.403 123.131 147.838 123.131 139.739C123.131 131.641 116.577 125.075 108.493 125.075C100.409 125.075 93.8552 131.641 93.8552 139.739C93.8552 147.838 100.409 154.403 108.493 154.403Z",
    fill: "#08080D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.493 149.875C114.081 149.875 118.611 145.337 118.611 139.739C118.611 134.142 114.081 129.604 108.493 129.604C102.905 129.604 98.3757 134.142 98.3757 139.739C98.3757 145.337 102.905 149.875 108.493 149.875Z",
    fill: "#1E1E2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.493 145.131C111.465 145.131 113.875 142.717 113.875 139.739C113.875 136.762 111.465 134.348 108.493 134.348C105.521 134.348 103.112 136.762 103.112 139.739C103.112 142.717 105.521 145.131 108.493 145.131Z",
    fill: "#050508"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.53 0H156.928C137.311 0 121.409 15.9305 121.409 35.5818V643.146C121.409 662.798 137.311 678.728 156.928 678.728H399.53C419.147 678.728 435.049 662.798 435.049 643.146V35.5818C435.049 15.9305 419.147 0 399.53 0Z",
    fill: "#0C0C12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.315 6.4694C407.042 6.46919 414.456 9.52948 419.941 14.983C425.425 20.4365 428.534 27.8409 428.591 35.5818V643.06C428.591 646.901 427.832 650.705 426.359 654.251C424.885 657.797 422.725 661.016 420.003 663.722C417.282 666.428 414.053 668.568 410.502 670.019C406.952 671.469 403.15 672.201 399.315 672.173H156.928C149.22 672.173 141.829 669.105 136.379 663.646C130.929 658.186 127.867 650.781 127.867 643.06V35.5818C127.923 27.8781 131.003 20.506 136.441 15.0586C141.879 9.61115 149.238 6.52584 156.928 6.4694H399.315ZM399.315 -1.78483e-05H156.928C152.263 -1.78483e-05 147.645 0.920333 143.335 2.70849C139.026 4.49664 135.11 7.11757 131.812 10.4216C128.514 13.7257 125.898 17.6482 124.113 21.9652C122.328 26.2822 121.409 30.9091 121.409 35.5818V643.06C121.409 647.733 122.328 652.36 124.113 656.677C125.898 660.994 128.514 664.916 131.812 668.22C135.11 671.524 139.026 674.145 143.335 675.933C147.645 677.722 152.263 678.642 156.928 678.642H399.315C403.998 678.67 408.639 677.771 412.974 675.996C417.308 674.22 421.249 671.604 424.57 668.297C427.891 664.99 430.526 661.058 432.325 656.727C434.123 652.396 435.049 647.751 435.049 643.06V35.5818C435.049 30.8909 434.123 26.2463 432.325 21.9152C430.526 17.5841 427.891 13.652 424.57 10.3451C421.249 7.03819 417.308 4.42176 412.974 2.64634C408.639 0.87092 403.998 -0.0284474 399.315 -1.78483e-05Z",
    fill: "#FF9191"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 137,
    y: 38,
    width: 283,
    height: 622
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.462 38.7115H161.546C147.993 38.7115 137.006 49.718 137.006 63.2953V634.588C137.006 648.165 147.993 659.172 161.546 659.172H394.462C408.015 659.172 419.002 648.165 419.002 634.588V63.2953C419.002 49.718 408.015 38.7115 394.462 38.7115Z",
    fill: "#36393F"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M345.28 57.1874H112.364C98.8113 57.1874 87.8243 68.1939 87.8243 81.7712V653.064C87.8243 666.641 98.8113 677.648 112.364 677.648H345.28C358.833 677.648 369.82 666.641 369.82 653.064V81.7712C369.82 68.1939 358.833 57.1874 345.28 57.1874Z",
    fill: "#36393F"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 135.25,
    y: 34.3124,
    width: 381.108,
    height: 466.297,
    rx: 8,
    fill: "#292841"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.57 87.9806C161.259 87.9806 161.023 87.6997 161.077 87.3934L161.597 84.4614H158.679C158.368 84.4614 158.133 84.1813 158.186 83.8754L158.319 83.1157C158.361 82.8764 158.568 82.7018 158.811 82.7018H161.904L162.835 77.4229H159.917C159.606 77.4229 159.371 77.1428 159.425 76.8369L159.557 76.0773C159.599 75.838 159.807 75.6633 160.05 75.6633H163.142L163.693 72.5569C163.735 72.3181 163.943 72.1441 164.185 72.1441H164.926C165.237 72.1441 165.473 72.4251 165.418 72.7313L164.899 75.6633H170.168L170.719 72.5569C170.761 72.3181 170.969 72.1441 171.211 72.1441H171.952C172.263 72.1441 172.499 72.4251 172.444 72.7313L171.925 75.6633H174.843C175.154 75.6633 175.389 75.9435 175.336 76.2494L175.203 77.009C175.161 77.2483 174.953 77.4229 174.71 77.4229H171.618L170.687 82.7018H173.605C173.915 82.7018 174.151 82.9819 174.097 83.2878L173.965 84.0474C173.923 84.2868 173.715 84.4614 173.472 84.4614H170.379L169.829 87.5679C169.786 87.8066 169.579 87.9806 169.336 87.9806H168.596C168.285 87.9806 168.049 87.6997 168.103 87.3934L168.623 84.4614H163.353L162.803 87.5679C162.761 87.8066 162.553 87.9806 162.311 87.9806H161.57ZM164.592 77.4229L163.661 82.7018H168.931L169.861 77.4229H164.592Z",
    fill: "#B9BBBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.791 83.7224C191.791 82.1211 190.93 81.5228 188.735 80.9598C187.47 80.6254 187.154 80.3615 187.154 79.904C187.154 79.4465 187.54 79.1298 188.331 79.1298C189.174 79.1298 190.175 79.4289 191.018 79.904L191.299 78.1444C190.456 77.7749 189.437 77.5461 188.331 77.5461C186.363 77.5461 185.204 78.5843 185.204 80.0624C185.204 81.6108 186.065 82.2091 188.12 82.737C189.472 83.0713 189.841 83.3176 189.841 83.9159C189.841 84.479 189.349 84.8133 188.436 84.8133C187.382 84.8133 186.258 84.4086 185.345 83.8103L185.063 85.57C185.871 86.0099 187.136 86.397 188.366 86.397C190.596 86.397 191.791 85.394 191.791 83.7224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.994 86.221L197.731 84.4438C197.538 84.4966 197.309 84.5142 197.063 84.5142C196.255 84.5142 195.957 84.1447 195.957 83.4584V79.4465H197.942L197.678 77.7221H195.957V74.7131L193.866 75.0299V77.7221H192.672V79.4465H193.866V83.8103C193.866 85.7459 194.991 86.3618 196.659 86.3618C197.274 86.3618 197.661 86.2914 197.994 86.221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.533 77.7221V83.8279C199.533 85.4292 200.359 86.397 201.957 86.397C203.081 86.397 203.995 85.7811 204.785 85.0245L204.978 86.221H206.77V77.7221H204.662V83.4584C204.047 84.0919 203.38 84.5142 202.73 84.5142C201.957 84.5142 201.641 84.0215 201.641 83.2825V77.7221H199.533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.62 82.0859C210.62 80.2207 211.411 79.3233 212.518 79.3233C213.238 79.3233 213.642 79.4465 214.169 79.6928V83.3352C213.607 84.0567 213.009 84.5142 212.236 84.5142C211.306 84.5142 210.62 83.74 210.62 82.0859ZM208.495 82.2091C208.495 85.0773 209.918 86.397 211.692 86.397C212.869 86.397 213.694 85.7635 214.292 85.0421L214.467 86.221H216.276V73.5166L214.169 73.8509V77.9508C213.659 77.7749 213.009 77.6341 212.201 77.6341C210.234 77.6341 208.495 79.0418 208.495 82.2091Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.315 89.4235C220.844 89.4235 221.827 88.8076 222.547 86.7665L225.797 77.7221H223.671L221.774 83.7048L219.842 77.5989L217.647 77.8804L220.721 86.2034L220.65 86.4498C220.369 87.3648 219.807 87.6815 219.105 87.6815C218.736 87.6815 218.437 87.6287 218.174 87.5583L218.455 89.3355C218.648 89.3883 218.859 89.4235 219.315 89.4235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.249 82.1739V80.1327H226.682V82.1739H231.249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.739 80.4847C237.739 81.4173 237.177 82.1035 236.246 82.1035C235.333 82.1035 234.771 81.4349 234.771 80.5551C234.771 79.6225 235.315 78.901 236.246 78.901C237.142 78.901 237.739 79.5873 237.739 80.4847ZM240.743 86.5729C240.743 85.2708 239.654 84.7253 237.915 84.479L236.826 84.3734C235.508 84.1799 235.245 84.1095 235.245 83.8279C235.245 83.6872 235.385 83.5288 235.596 83.3704C235.807 83.4056 236.035 83.4232 236.281 83.4232C238.108 83.4232 239.671 82.3323 239.671 80.5023C239.671 80.1152 239.601 79.728 239.443 79.3937L240.989 79.2881L240.707 77.5989L238.635 78.3379C238.02 77.8277 237.212 77.5461 236.228 77.5461C234.331 77.5461 232.821 78.6899 232.821 80.5551C232.821 81.6812 233.418 82.561 234.419 83.0361C233.717 83.4584 233.348 83.9159 233.348 84.391C233.348 84.7253 233.506 85.0421 233.84 85.306C232.786 85.9043 232.241 86.5201 232.241 87.312C232.241 88.7197 233.98 89.4235 236.281 89.4235C238.74 89.4235 240.743 88.4029 240.743 86.5729ZM236.422 88.1742C234.823 88.1742 234.068 87.7167 234.068 87.0832C234.068 86.6433 234.349 86.2386 234.964 85.7987C235.385 85.8867 235.649 85.9395 236.228 86.0099L237.37 86.1506C238.424 86.309 238.793 86.5729 238.793 87.0304C238.793 87.6639 237.932 88.1742 236.422 88.1742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.357 79.6401L247.023 77.5461C245.706 77.6165 244.863 78.4435 244.3 79.4289L244.037 77.7221H242.245V86.221H244.353V81.3469C244.968 80.4319 246.039 79.728 247.357 79.6401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.025 81.9627C256.025 79.2002 254.339 77.5461 252.02 77.5461C249.719 77.5461 248.033 79.2177 248.033 81.9803C248.033 84.7429 249.702 86.397 252.003 86.397C254.321 86.397 256.025 84.7253 256.025 81.9627ZM253.97 81.9803C253.97 83.564 253.302 84.6725 252.003 84.6725C250.773 84.6725 250.088 83.5288 250.088 81.9627C250.088 80.3967 250.755 79.2705 252.003 79.2705C253.267 79.2705 253.97 80.4143 253.97 81.9803Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7 77.7221V83.8279C257.7 85.4292 258.525 86.397 260.124 86.397C261.248 86.397 262.161 85.7811 262.951 85.0245L263.145 86.221H264.936V77.7221H262.829V83.4584C262.214 84.0919 261.546 84.5142 260.896 84.5142C260.124 84.5142 259.807 84.0215 259.807 83.2825V77.7221H257.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.739 81.8572C272.739 83.7224 271.914 84.6198 270.825 84.6198C270.104 84.6198 269.7 84.4966 269.191 84.2502V80.6078C269.753 79.8864 270.35 79.4113 271.106 79.4113C272.054 79.4113 272.739 80.2207 272.739 81.8572ZM274.864 81.734C274.864 78.8834 273.442 77.5461 271.668 77.5461C270.491 77.5461 269.665 78.1972 269.068 78.8834L268.875 77.7221H267.083V89.4939L269.191 89.1772V85.9747C269.7 86.1682 270.35 86.309 271.158 86.309C273.108 86.309 274.864 84.9013 274.864 81.734Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 114,
    width: 36,
    height: 36
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.892,
    cy: 131.971,
    rx: 17.5649,
    ry: 17.5961,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.892,
    cy: 131.971,
    rx: 17.5649,
    ry: 17.5961,
    fill: "#CFDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.526 155.582C193.193 154.757 192.642 154.039 191.931 153.504C191.221 152.969 190.379 152.638 189.496 152.546L187.651 152.351C185.006 142.8 186.344 140.631 178.529 138.49L172.203 138.267C172.203 138.267 165.775 138.377 163.41 141.547L166.713 152.401C166.713 152.401 165.358 159.606 165.973 163.258L174.213 162.191L177.782 173.763C191.246 171.759 197.519 165.508 197.519 165.508L193.526 155.582Z",
    fill: "#CFDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.917 139.121C173.886 147.534 181.991 153.282 180.63 140.008L164.917 139.121Z",
    fill: "#B8C5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.32 140.113C177.129 143.787 179.156 145.173 178.646 140.756L169.32 140.113Z",
    fill: "#5697B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.175 146.292C185.225 142.278 184.511 140.548 180.511 139.099C181.586 141.621 182.054 146.826 182.054 146.826L186.175 146.292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.845 126.897L172.56 124.678C172.463 123.954 172.14 123.279 171.636 122.752C171.132 122.224 170.473 121.871 169.755 121.743C168.967 121.605 168.155 121.75 167.462 122.152C166.769 122.554 166.239 123.187 165.965 123.941C164.959 126.674 163.388 131.072 162.304 134.771C160.578 140.664 168.379 142.026 176.046 141.438C183.712 140.85 184.434 137.487 183.375 132.62C182.695 129.584 181.834 126.485 181.297 124.558C181.133 124.021 180.816 123.543 180.385 123.182C179.953 122.822 179.427 122.595 178.869 122.53C178.244 122.457 177.613 122.595 177.074 122.921C176.536 123.248 176.121 123.744 175.895 124.332L175.033 126.614L172.845 126.897Z",
    fill: "#7CE4CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.346 134.954L181.802 134.764L179.009 135.733L176.168 136.101L171.246 135.119C171.246 135.119 168.541 130.928 168.736 135.588C168.891 138.808 170.255 140.656 171.086 141.503C172.738 141.578 174.394 141.547 176.043 141.411C177.287 141.341 178.519 141.133 179.718 140.79C180.548 139.612 181.887 137.443 182.346 134.954Z",
    fill: "#AAFAE7"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.74,
    d: "M168.657 135.191C168.024 133.422 166.88 129.693 167.356 126.883C167.832 124.073 168.46 121.764 169.757 121.741C168.968 121.603 168.156 121.748 167.463 122.15C166.77 122.552 166.24 123.185 165.966 123.939C164.96 126.673 163.388 131.071 162.304 134.77C160.757 140.033 166.833 141.676 173.635 141.547C172.159 141.305 170.284 139.754 168.657 135.191Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.635 141.549L173.088 141.562L172.569 141.571L171.755 141.532L171.499 141.565L171.09 141.531C170.263 140.713 168.898 138.864 168.744 135.644C168.732 135.586 168.734 135.527 168.75 135.47C170.348 139.805 172.191 141.331 173.635 141.549Z",
    fill: "#AAFAE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.676 134.463L181.672 135.112C178.684 137.069 178.199 137.61 170.505 135.193L170.427 134.588L170.76 134.682C177.276 136.33 178.52 136.476 181.676 134.463Z",
    fill: "#2C4661"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.898 136.989C170.904 136.708 171.466 135.565 171.152 134.435C170.838 133.306 169.768 132.618 168.762 132.898C167.756 133.179 167.195 134.322 167.509 135.452C167.822 136.582 168.892 137.27 169.898 136.989Z",
    fill: "#738EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.112 134.646C183.316 133.669 183.031 132.781 182.473 132.665C181.916 132.548 181.299 133.245 181.094 134.222C180.889 135.199 181.175 136.087 181.732 136.204C182.289 136.32 182.907 135.623 183.112 134.646Z",
    fill: "#738EFF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M175.479 132.776C175.336 132.563 175.577 132.416 175.769 132.334C175.846 132.304 175.931 132.299 176.011 132.32C176.091 132.341 176.163 132.386 176.217 132.449L176.945 133.396C177.156 133.687 176.84 133.699 176.527 133.508C176.213 133.317 175.697 133.124 175.479 132.776Z",
    fill: "#284E7A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M178.742 133.222L178.964 132.701C179.003 132.612 179.015 132.513 178.997 132.418C178.98 132.322 178.934 132.234 178.866 132.164L178.766 132.061C178.757 132.051 178.745 132.042 178.732 132.037C178.719 132.032 178.705 132.031 178.691 132.032C178.676 132.034 178.663 132.04 178.652 132.048C178.64 132.056 178.631 132.067 178.624 132.08C178.489 132.451 178.383 132.832 178.309 133.22C178.275 133.629 178.531 133.596 178.742 133.222Z",
    fill: "#284E7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.584 127.091L172.843 126.896L175.031 126.613L175.893 124.332C176.119 123.744 176.534 123.248 177.072 122.921C177.611 122.595 178.242 122.457 178.867 122.53L179.401 122.634C178.099 122.398 177.657 123.901 177.401 125.728C177.27 126.728 177.308 127.244 175.584 127.091Z",
    fill: "#61C7C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.696 126.674C180.701 125.977 180.242 125.409 179.673 125.405C179.104 125.402 178.639 125.965 178.634 126.662C178.63 127.36 179.088 127.928 179.657 127.931C180.227 127.934 180.692 127.372 180.696 126.674Z",
    fill: "#21354A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.053 126.257C171.122 125.563 170.718 124.955 170.151 124.899C169.585 124.843 169.07 125.36 169.001 126.054C168.932 126.748 169.336 127.356 169.903 127.412C170.469 127.468 170.984 126.951 171.053 126.257Z",
    fill: "#21354A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.714 152.397C167.901 152.417 169.414 152.279 170.765 152.219C170.739 151.679 170.786 151.138 170.904 150.61C171.111 149.724 171.428 148.866 171.847 148.058C170.766 147.967 169.454 147.876 168.381 147.842C168.158 142.519 165.361 139.641 163.817 141.114C163.086 141.81 162.641 142.755 162.57 143.763C162.53 144.578 162.613 145.898 162.565 146.194C162.43 147.166 161.745 147.457 162.583 149.258C163.017 150.156 162.204 152.373 166.714 152.397Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.415 121.945C171.516 122.641 171.793 124.341 171.881 125.024C171.969 125.707 172.126 126.931 172.166 127.244C172.207 127.557 172.307 127.66 173.35 128.132C174.393 128.605 173.958 128.14 173.483 127.594L172.844 126.896L172.558 124.676C172.478 124.071 172.237 123.498 171.86 123.017C171.483 122.537 170.984 122.166 170.415 121.945Z",
    fill: "#D4FFDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.102 125.842C180.497 125.993 180.586 126.907 180.194 126.553C179.801 126.199 179.558 125.652 180.102 125.842Z",
    fill: "#335A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.56 125.311C170.927 125.466 171.019 126.409 170.652 126.022C170.284 125.636 169.988 125.125 170.56 125.311Z",
    fill: "#335A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.479 135.803C170.857 135.603 170.888 134.919 170.548 134.274C170.208 133.63 169.626 133.269 169.248 133.469C168.871 133.669 168.84 134.354 169.18 134.998C169.52 135.643 170.102 136.003 170.479 135.803Z",
    fill: "#B2A6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.087 133.869C183.088 133.409 182.909 133.037 182.687 133.037C182.466 133.037 182.286 133.409 182.286 133.869C182.285 134.328 182.464 134.701 182.686 134.701C182.907 134.701 183.087 134.329 183.087 133.869Z",
    fill: "#B2A6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.199 123.457C180.812 123.956 180.986 124.859 180.298 124.225C179.61 123.591 179.457 122.858 180.199 123.457Z",
    fill: "#D4FFDC"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.509,
    y: 114.375,
    width: 42.1557,
    height: 17.5961,
    rx: 4,
    fill: "#2DDFB4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.178,
    y: 121.413,
    width: 42.1557,
    height: 10.5577,
    rx: 4,
    fill: "#72767D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.509 139.49C205.509 137.281 207.3 135.49 209.509 135.49H327.976C330.185 135.49 331.976 137.281 331.976 139.49V149.086C331.976 151.295 330.185 153.086 327.976 153.086H205.509V139.49Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 167,
    width: 36,
    height: 36
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.892,
    cy: 184.759,
    rx: 17.5649,
    ry: 17.5961,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.892,
    cy: 184.759,
    rx: 17.5649,
    ry: 17.5961,
    fill: "#F7E5BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.092 195.773L191.705 201.289C191.518 201.724 191.246 202.118 190.905 202.446C190.564 202.774 190.16 203.031 189.718 203.2C189.276 203.369 188.805 203.448 188.332 203.432C187.859 203.415 187.395 203.304 186.966 203.104L178.045 199.037L182.488 192.021L187.924 195.058L188.725 192.684C191.531 193.801 193.029 194.779 194.092 195.773Z",
    fill: "#F7E5BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.725 193.103C187.314 193.696 187.645 194.447 188.603 196.332L184.753 195.896L183.725 193.103Z",
    fill: "#F7E5BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.824 163.204C166.11 163.426 165.508 163.913 165.139 164.565C164.77 165.216 164.663 165.984 164.838 166.712L168.41 181.321L174.804 179.995L170.501 165.193C170.393 164.819 170.212 164.47 169.968 164.166C169.724 163.863 169.422 163.611 169.079 163.426C168.737 163.24 168.361 163.125 167.974 163.087C167.587 163.049 167.196 163.089 166.824 163.204Z",
    fill: "#D6569B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.379 177.9L172.905 177.795L170.222 168.998C170.185 168.872 170.122 168.755 170.038 168.653C169.953 168.552 169.849 168.47 169.731 168.411C169.613 168.352 169.485 168.318 169.353 168.311C169.222 168.304 169.091 168.324 168.967 168.37C168.751 168.453 168.573 168.613 168.467 168.819C168.361 169.025 168.334 169.263 168.392 169.487L170.379 177.9Z",
    fill: "#E374B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.617 163.134C182.333 163.349 182.941 163.83 183.316 164.479C183.692 165.127 183.807 165.894 183.638 166.625L180.223 181.251L173.811 180.012L177.958 165.158C178.062 164.783 178.24 164.432 178.481 164.126C178.722 163.82 179.022 163.565 179.363 163.376C179.704 163.188 180.078 163.069 180.465 163.028C180.852 162.986 181.244 163.022 181.617 163.134Z",
    fill: "#D6569B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.195 177.865L176.686 177.778L179.265 168.946C179.301 168.82 179.364 168.702 179.449 168.602C179.533 168.501 179.638 168.419 179.757 168.362C179.875 168.304 180.004 168.272 180.135 168.268C180.266 168.263 180.397 168.286 180.519 168.335C180.735 168.414 180.914 168.57 181.023 168.772C181.132 168.975 181.164 169.211 181.111 169.435L179.195 177.865Z",
    fill: "#E374B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.356 199.16L185.31 202.476L185.171 202.895L183.882 206.944H159.907C159.681 206.054 159.959 205.88 160.569 204.885C161.179 203.89 160.865 204.152 160.953 201.743C161.022 200.05 161.632 198.479 163.81 196.524C164.472 195.948 164.629 195.721 165.308 195.093L165.517 194.901L165.622 194.796L165.761 194.691L182.139 192.108L185.432 197.606L186.356 199.16Z",
    fill: "#F7E5BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.31 202.476C185.206 204.064 185.066 205.565 184.892 206.944H167.277C167.295 206.229 167.312 205.338 167.347 204.256C167.344 204.14 167.35 204.023 167.364 203.907V202.563C167.242 199.369 166.336 197.187 163.81 196.524C164.28 196.053 164.768 195.581 165.308 195.093L165.517 194.901L165.761 194.691L182.139 192.108C183.429 192.579 184.282 192.911 185.258 193.906C185.363 195.163 185.415 196.402 185.432 197.606C185.45 199.299 185.398 200.922 185.31 202.476Z",
    fill: "#1F3A70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.739 185.2L164.73 185.961C162.228 186.062 160.281 188.175 160.381 190.681L160.381 190.688C160.481 193.194 162.591 195.145 165.093 195.045L184.102 194.283C186.603 194.183 188.55 192.07 188.45 189.563L188.45 189.556C188.35 187.05 186.241 185.099 183.739 185.2Z",
    fill: "#F06EA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.746 176.757L164.276 177.533C161.632 177.644 159.579 179.881 159.69 182.529L159.696 182.688C159.807 185.337 162.04 187.394 164.684 187.283L183.154 186.507C185.798 186.396 187.852 184.159 187.741 181.511L187.734 181.352C187.623 178.703 185.39 176.646 182.746 176.757Z",
    fill: "#F06EA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.038 194.133C186.478 194.028 188.481 192.056 188.481 189.612C188.49 188.723 188.236 187.852 187.753 187.107C187.269 186.362 186.577 185.776 185.763 185.423C186.376 184.955 186.867 184.345 187.195 183.647C187.522 182.948 187.677 182.18 187.645 181.408V181.251C187.618 180.621 187.468 180.002 187.202 179.43C186.936 178.858 186.56 178.344 186.095 177.917C185.631 177.491 185.087 177.16 184.495 176.945C183.903 176.729 183.274 176.633 182.645 176.661L166.162 177.359C164.681 180.204 164.89 183.259 165.988 185.458C166.148 185.791 166.238 186.153 166.253 186.522C166.268 186.892 166.208 187.26 166.075 187.605C164.489 191.829 166.58 194.883 166.58 194.883L184.038 194.133Z",
    fill: "#E05FA3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.729 185.576C171.148 185.302 171.171 184.595 170.781 183.998C170.391 183.402 169.736 183.14 169.317 183.415C168.898 183.689 168.875 184.396 169.265 184.992C169.655 185.589 170.31 185.851 170.729 185.576Z",
    fill: "#1B1926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.985 184.273C179.166 183.623 178.952 182.995 178.507 182.871C178.062 182.746 177.555 183.172 177.374 183.822C177.192 184.472 177.406 185.1 177.851 185.224C178.296 185.349 178.803 184.923 178.985 184.273Z",
    fill: "#1B1926"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.557 187.675C173.706 189.63 175.397 190.083 176.529 187.552C176.542 187.53 176.549 187.504 176.548 187.478C176.548 187.451 176.54 187.426 176.525 187.404C176.511 187.382 176.49 187.365 176.466 187.354C176.442 187.343 176.416 187.339 176.39 187.343L172.678 187.448C172.653 187.451 172.629 187.46 172.608 187.474C172.588 187.488 172.57 187.507 172.558 187.529C172.546 187.552 172.54 187.576 172.54 187.602C172.539 187.627 172.545 187.652 172.557 187.675Z",
    fill: "#751B40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.874 187.395L172.678 187.448C172.653 187.451 172.629 187.46 172.608 187.474C172.588 187.488 172.57 187.507 172.558 187.529C172.546 187.552 172.54 187.576 172.54 187.602C172.539 187.627 172.545 187.652 172.557 187.675C173.55 189.35 174.926 189.926 176.024 188.46C175.751 188.001 175.352 187.631 174.874 187.395Z",
    fill: "#9C2455"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.509,
    y: 167.163,
    width: 42.1557,
    height: 17.5961,
    rx: 4,
    fill: "#BED3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.178,
    y: 174.202,
    width: 42.1557,
    height: 10.5577,
    rx: 4,
    fill: "#72767D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.509 192.279C205.509 190.069 207.3 188.279 209.509 188.279H370.132C372.341 188.279 374.132 190.069 374.132 192.279V205.875H205.509V192.279Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.509 205.875H374.132V219.471C374.132 221.68 372.341 223.471 370.132 223.471H209.509C207.3 223.471 205.509 221.68 205.509 219.471V205.875Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 237,
    width: 36,
    height: 36
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.892,
    cy: 255.144,
    rx: 17.5649,
    ry: 17.5961,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.892,
    cy: 255.144,
    rx: 17.5649,
    ry: 17.5961,
    fill: "#FFB869"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.878 260.89C166.928 268.032 175.175 272.979 181.791 268.312C188.407 263.644 181.838 254.076 181.838 254.076C181.838 254.076 185.425 245.021 176.433 242.874C167.441 240.727 165.204 244.648 164.878 260.89Z",
    fill: "#4D7AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.203 255.663C177.2 255.663 176.386 254.576 176.386 253.236C176.386 251.895 177.2 250.809 178.203 250.809C179.207 250.809 180.021 251.895 180.021 253.236C180.021 254.576 179.207 255.663 178.203 255.663Z",
    fill: "#DBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.983 255.079C178.726 255.061 178.545 254.651 178.578 254.162C178.611 253.674 178.847 253.292 179.103 253.309C179.36 253.327 179.541 253.737 179.508 254.226C179.475 254.714 179.239 255.096 178.983 255.079Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.3 248.708C180.179 248.346 179.948 248.031 179.639 247.807C179.329 247.584 178.958 247.464 178.576 247.464C178.195 247.464 177.823 247.584 177.514 247.807C177.204 248.031 176.973 248.346 176.852 248.708H180.3Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.114 259.023C178.343 259.49 176.433 259.07 174.849 257.343C174.642 257.107 174.351 256.96 174.039 256.934C173.726 256.908 173.415 257.004 173.172 257.203C172.907 257.383 172.724 257.661 172.662 257.976C172.601 258.291 172.667 258.617 172.845 258.883C175.268 262.851 179.042 263.457 181.372 261.217C181.532 261.073 181.65 260.889 181.716 260.684C181.781 260.479 181.791 260.26 181.745 260.05C181.712 259.872 181.643 259.702 181.542 259.551C181.44 259.401 181.308 259.273 181.155 259.177C181.002 259.08 180.83 259.017 180.651 258.99C180.471 258.964 180.289 258.975 180.114 259.023Z",
    fill: "#590942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.763 259.21C179.22 259.214 179.675 259.151 180.114 259.023H180.533V260.19C180.533 260.19 179.834 260.704 177.225 260.424V259.77L172.659 258.23C172.661 258.038 172.708 257.848 172.797 257.678C172.886 257.508 173.015 257.361 173.172 257.25C173.172 257.237 173.177 257.226 173.185 257.217C173.194 257.208 173.206 257.203 173.218 257.203C173.41 257.072 173.639 257.006 173.871 257.016C173.917 256.97 174.01 257.016 174.057 257.016H174.476C174.523 257.063 174.569 257.063 174.569 257.11C174.569 257.156 174.663 257.11 174.663 257.156L174.849 257.296C175.125 257.613 175.438 257.895 175.781 258.137L176.433 258.557C176.737 258.744 177.067 258.886 177.411 258.977C177.847 259.127 178.303 259.206 178.763 259.21Z",
    fill: "#DBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.172 257.203C173.172 257.191 173.177 257.179 173.185 257.17C173.194 257.161 173.206 257.156 173.218 257.156C173.41 257.025 173.639 256.96 173.871 256.97C173.917 256.923 174.01 256.97 174.057 256.97H174.476C174.523 257.016 174.569 257.016 174.569 257.063C174.569 257.11 174.663 257.063 174.663 257.11L174.849 257.25C174.996 257.444 175.168 257.616 175.361 257.763L174.057 258.557L172.659 258.09C172.675 257.914 172.729 257.743 172.817 257.59C172.906 257.436 173.027 257.305 173.172 257.203Z",
    fill: "#B5CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.789 246.141C168.466 242.407 171.401 241.661 176.433 242.874C177.446 243.101 178.42 243.478 179.322 243.994C179.601 245.488 177.318 245.955 173.078 244.601C174.476 247.121 171.588 251.602 166.789 246.141Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.659 242.734L172.892 239.653C172.913 239.372 172.873 239.09 172.775 238.826C172.677 238.561 172.523 238.321 172.324 238.122C172.125 237.923 171.886 237.768 171.622 237.67C171.358 237.572 171.076 237.532 170.795 237.553C170.479 237.571 170.172 237.666 169.9 237.829C169.629 237.992 169.401 238.218 169.236 238.489C169.071 238.76 168.974 239.067 168.953 239.384C168.933 239.7 168.989 240.017 169.118 240.307L170.516 243.481L172.659 242.734Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.545 259.21L161.943 259.724L164.878 257.81V260.19L167.301 262.104C167.81 262.523 168.229 263.041 168.533 263.627C168.838 264.212 169.021 264.853 169.072 265.511L169.165 267.425C172.706 270.365 177.551 271.299 181.791 268.312C182.481 267.85 183.094 267.283 183.608 266.631L185.053 267.145C185.053 267.145 182.117 279.514 177.225 281.754C172.333 283.995 168.932 281.754 168.932 281.754C163.807 264.298 165.298 261.03 152.625 266.071L152.019 262.524L160.545 259.21Z",
    fill: "#EF6767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.702 253.656L161.477 245.021L160.638 246.095L167.767 259.397L170.702 253.656Z",
    fill: "#4D7AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.348 251.696L163.714 249.128L166.509 254.169L165.996 252.209L167.348 251.696Z",
    fill: "#3366E0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.509,
    y: 237.548,
    width: 42.1557,
    height: 17.5961,
    rx: 4,
    fill: "#FDD171"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.178,
    y: 244.586,
    width: 42.1557,
    height: 10.5577,
    rx: 4,
    fill: "#72767D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 205,
    y: 258,
    width: 170,
    height: 96
  }, /*#__PURE__*/React.createElement("path", {
    d: "M205.509 262.663C205.509 260.454 207.3 258.663 209.509 258.663H370.132C372.341 258.663 374.132 260.454 374.132 262.663V349.682C374.132 351.891 372.341 353.682 370.132 353.682H209.509C207.3 353.682 205.509 351.891 205.509 349.682V262.663Z",
    fill: "#DCDDDE"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M533.866 237.548H-122.076V366.015H533.866V237.548Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.106 237.548C151.342 286.862 36.3376 366.014 36.3376 366.014H-14.0974L160.786 237.548H251.106Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.455 237.548C327.23 273.399 215.38 319.225 215.38 319.225C245.125 299.236 336.039 250.374 371.601 237.548H419.455Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.594 265.847C278.147 249.286 294.842 241.098 294.842 241.098C273.804 244.012 261.41 253.185 250.594 265.847Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M343.167 328.931C345.359 317.501 343.659 303.115 324.812 293.778C311.517 287.642 294.986 296.404 296.809 316.926C291.237 317.029 286.566 318.876 283.616 323.739C269.277 313.171 244.919 321.523 250.43 349.597C234.083 349.125 226.36 354.358 223.553 366.014H324.812L390.57 365.953C385.47 345.985 367.238 330.635 343.167 328.931Z",
    fill: "#7196FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M282.797 334.308C283.37 324.827 290.151 318.732 296.809 316.926C291.237 317.029 286.566 318.876 283.616 323.74C275.893 318.055 265.282 317.85 257.969 323.247C264.913 318.589 278.372 326.51 282.797 334.308Z",
    fill: "#83A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.962 366.014C461.962 340.896 444.447 340.218 444.447 340.218C448.954 314.464 424.023 293.285 398.703 307.486C373.383 321.687 387.232 345.308 387.232 345.308C367.299 341.347 340.627 345.267 335.24 366.014H461.962Z",
    fill: "#5E87F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.541 366.014C233.099 360.494 222.672 358.031 214.929 359.489C211.139 352.244 199.483 348.243 190.94 356.287C183.217 355.589 173.016 358.155 172.032 366.014H236.541Z",
    fill: "#83A4FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 367,
    width: 36,
    height: 36
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.892,
    cy: 385.355,
    rx: 17.5649,
    ry: 17.5961,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.892,
    cy: 385.355,
    rx: 17.5649,
    ry: 17.5961,
    fill: "#FFB869"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.878 391.102C166.928 398.243 175.175 403.19 181.791 398.523C188.407 393.856 181.838 384.287 181.838 384.287C181.838 384.287 185.425 375.232 176.433 373.085C167.441 370.938 165.204 374.859 164.878 391.102Z",
    fill: "#4D7AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.203 385.874C177.2 385.874 176.386 384.788 176.386 383.447C176.386 382.107 177.2 381.02 178.203 381.02C179.207 381.02 180.021 382.107 180.021 383.447C180.021 384.788 179.207 385.874 178.203 385.874Z",
    fill: "#DBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.983 385.29C178.726 385.273 178.545 384.862 178.578 384.374C178.611 383.885 178.847 383.503 179.103 383.52C179.36 383.538 179.541 383.948 179.508 384.437C179.475 384.926 179.239 385.308 178.983 385.29Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.3 378.92C180.179 378.557 179.948 378.242 179.639 378.018C179.329 377.795 178.958 377.675 178.576 377.675C178.195 377.675 177.823 377.795 177.514 378.018C177.204 378.242 176.973 378.557 176.852 378.92H180.3Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.114 389.235C178.343 389.702 176.433 389.282 174.849 387.555C174.642 387.318 174.351 387.171 174.039 387.145C173.726 387.119 173.415 387.216 173.172 387.415C172.907 387.595 172.724 387.872 172.662 388.187C172.601 388.502 172.667 388.828 172.845 389.095C175.268 393.062 179.042 393.669 181.372 391.429C181.532 391.285 181.65 391.101 181.716 390.896C181.781 390.691 181.791 390.472 181.745 390.262C181.712 390.083 181.643 389.913 181.542 389.763C181.44 389.612 181.308 389.485 181.155 389.388C181.002 389.292 180.83 389.228 180.651 389.202C180.471 389.175 180.289 389.187 180.114 389.235Z",
    fill: "#590942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.763 389.421C179.22 389.425 179.675 389.362 180.114 389.235H180.533V390.402C180.533 390.402 179.834 390.915 177.225 390.635V389.982L172.659 388.441C172.661 388.249 172.708 388.06 172.797 387.889C172.886 387.719 173.015 387.572 173.172 387.461C173.172 387.449 173.177 387.437 173.185 387.428C173.194 387.419 173.206 387.414 173.218 387.414C173.41 387.283 173.639 387.218 173.871 387.228C173.917 387.181 174.01 387.228 174.057 387.228H174.476C174.523 387.274 174.569 387.274 174.569 387.321C174.569 387.368 174.663 387.321 174.663 387.368L174.849 387.508C175.125 387.824 175.438 388.106 175.781 388.348L176.433 388.768C176.737 388.955 177.067 389.097 177.411 389.188C177.847 389.338 178.303 389.417 178.763 389.421Z",
    fill: "#DBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.172 387.415C173.172 387.402 173.177 387.39 173.185 387.382C173.194 387.373 173.206 387.368 173.218 387.368C173.41 387.237 173.639 387.171 173.871 387.181C173.917 387.134 174.01 387.181 174.057 387.181H174.476C174.523 387.228 174.569 387.228 174.569 387.274C174.569 387.321 174.663 387.274 174.663 387.321L174.849 387.461C174.996 387.655 175.168 387.828 175.361 387.975L174.057 388.768L172.659 388.301C172.675 388.125 172.729 387.954 172.817 387.801C172.906 387.648 173.027 387.516 173.172 387.415Z",
    fill: "#B5CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.789 376.353C168.466 372.619 171.401 371.872 176.433 373.085C177.446 373.312 178.42 373.69 179.322 374.206C179.601 375.699 177.318 376.166 173.078 374.812C174.476 377.333 171.588 381.814 166.789 376.353Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.659 372.945L172.892 369.865C172.913 369.584 172.873 369.301 172.775 369.037C172.677 368.773 172.523 368.533 172.324 368.333C172.125 368.134 171.886 367.98 171.622 367.882C171.358 367.783 171.076 367.744 170.795 367.764C170.479 367.782 170.172 367.877 169.9 368.04C169.629 368.203 169.401 368.43 169.236 368.701C169.071 368.971 168.974 369.278 168.953 369.595C168.933 369.911 168.989 370.228 169.118 370.518L170.516 373.692L172.659 372.945Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.545 389.421L161.943 389.935L164.878 388.021V390.402L167.301 392.315C167.81 392.735 168.229 393.252 168.533 393.838C168.838 394.423 169.021 395.064 169.072 395.723L169.165 397.636C172.706 400.577 177.551 401.51 181.791 398.523C182.481 398.062 183.094 397.495 183.608 396.843L185.053 397.356C185.053 397.356 182.117 409.725 177.225 411.966C172.333 414.206 168.932 411.966 168.932 411.966C163.807 394.509 165.298 391.242 152.625 396.283L152.019 392.735L160.545 389.421Z",
    fill: "#EF6767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.702 383.867L161.477 375.232L160.638 376.306L167.767 389.608L170.702 383.867Z",
    fill: "#4D7AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.348 381.907L163.714 379.34L166.509 384.381L165.996 382.42L167.348 381.907Z",
    fill: "#3366E0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.509,
    y: 367.759,
    width: 42.1557,
    height: 17.5961,
    rx: 4,
    fill: "#FDD171"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.178,
    y: 374.797,
    width: 42.1557,
    height: 10.5577,
    rx: 4,
    fill: "#72767D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.509 392.874C205.509 390.665 207.3 388.874 209.509 388.874H370.132C372.341 388.874 374.132 390.665 374.132 392.874V402.471C374.132 404.68 372.341 406.471 370.132 406.471H205.509V392.874Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.509 406.471H289.82V420.067C289.82 422.276 288.029 424.067 285.82 424.067H209.509C207.3 424.067 205.509 422.276 205.509 420.067V406.471Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 438,
    width: 36,
    height: 36
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.892,
    cy: 455.74,
    rx: 17.5649,
    ry: 17.5961,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.892,
    cy: 455.74,
    rx: 17.5649,
    ry: 17.5961,
    fill: "#FFB869"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.878 461.486C166.928 468.627 175.175 473.575 181.791 468.908C188.407 464.24 181.838 454.672 181.838 454.672C181.838 454.672 185.425 445.617 176.433 443.47C167.441 441.323 165.204 445.243 164.878 461.486Z",
    fill: "#4D7AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.203 456.259C177.2 456.259 176.386 455.172 176.386 453.832C176.386 452.491 177.2 451.405 178.203 451.405C179.207 451.405 180.021 452.491 180.021 453.832C180.021 455.172 179.207 456.259 178.203 456.259Z",
    fill: "#DBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.983 455.675C178.726 455.657 178.545 455.247 178.578 454.758C178.611 454.269 178.847 453.887 179.103 453.905C179.36 453.923 179.541 454.333 179.508 454.822C179.475 455.31 179.239 455.692 178.983 455.675Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.3 449.304C180.179 448.942 179.948 448.626 179.639 448.403C179.329 448.18 178.958 448.059 178.576 448.059C178.195 448.059 177.823 448.18 177.514 448.403C177.204 448.626 176.973 448.942 176.852 449.304H180.3Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.114 459.619C178.343 460.086 176.433 459.666 174.849 457.939C174.642 457.702 174.351 457.556 174.039 457.529C173.726 457.503 173.415 457.6 173.172 457.799C172.907 457.979 172.724 458.257 172.662 458.572C172.601 458.886 172.667 459.213 172.845 459.479C175.268 463.447 179.042 464.053 181.372 461.813C181.532 461.669 181.65 461.485 181.716 461.28C181.781 461.075 181.791 460.856 181.745 460.646C181.712 460.467 181.643 460.298 181.542 460.147C181.44 459.997 181.308 459.869 181.155 459.773C181.002 459.676 180.83 459.612 180.651 459.586C180.471 459.56 180.289 459.571 180.114 459.619Z",
    fill: "#590942"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.763 459.806C179.22 459.81 179.675 459.747 180.114 459.619H180.533V460.786C180.533 460.786 179.834 461.3 177.225 461.019V460.366L172.659 458.826C172.661 458.633 172.708 458.444 172.797 458.274C172.886 458.103 173.015 457.957 173.172 457.846C173.172 457.833 173.177 457.821 173.185 457.813C173.194 457.804 173.206 457.799 173.218 457.799C173.41 457.668 173.639 457.602 173.871 457.612C173.917 457.566 174.01 457.612 174.057 457.612H174.476C174.523 457.659 174.569 457.659 174.569 457.706C174.569 457.752 174.663 457.706 174.663 457.752L174.849 457.892C175.125 458.209 175.438 458.491 175.781 458.732L176.433 459.153C176.737 459.34 177.067 459.481 177.411 459.573C177.847 459.723 178.303 459.801 178.763 459.806Z",
    fill: "#DBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.172 457.799C173.172 457.787 173.177 457.775 173.185 457.766C173.194 457.757 173.206 457.752 173.218 457.752C173.41 457.621 173.639 457.555 173.871 457.566C173.917 457.519 174.01 457.566 174.057 457.566H174.476C174.523 457.612 174.569 457.612 174.569 457.659C174.569 457.706 174.663 457.659 174.663 457.706L174.849 457.846C174.996 458.04 175.168 458.212 175.361 458.359L174.057 459.153L172.659 458.686C172.675 458.51 172.729 458.339 172.817 458.186C172.906 458.032 173.027 457.9 173.172 457.799Z",
    fill: "#B5CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.789 446.737C168.466 443.003 171.401 442.256 176.433 443.47C177.446 443.697 178.42 444.074 179.322 444.59C179.601 446.084 177.318 446.55 173.078 445.197C174.476 447.717 171.588 452.198 166.789 446.737Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.659 443.33L172.892 440.249C172.913 439.968 172.873 439.686 172.775 439.421C172.677 439.157 172.523 438.917 172.324 438.718C172.125 438.518 171.886 438.364 171.622 438.266C171.358 438.168 171.076 438.128 170.795 438.149C170.479 438.167 170.172 438.261 169.9 438.425C169.629 438.588 169.401 438.814 169.236 439.085C169.071 439.356 168.974 439.663 168.953 439.979C168.933 440.296 168.989 440.613 169.118 440.903L170.516 444.077L172.659 443.33Z",
    fill: "#201E2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.545 459.806L161.943 460.319L164.878 458.406V460.786L167.301 462.7C167.81 463.119 168.229 463.637 168.533 464.222C168.838 464.808 169.021 465.449 169.072 466.107L169.165 468.021C172.706 470.961 177.551 471.895 181.791 468.908C182.481 468.446 183.094 467.879 183.608 467.227L185.053 467.741C185.053 467.741 182.117 480.11 177.225 482.35C172.333 484.59 168.932 482.35 168.932 482.35C163.807 464.894 165.298 461.626 152.625 466.667L152.019 463.12L160.545 459.806Z",
    fill: "#EF6767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.702 454.252L161.477 445.617L160.638 446.69L167.767 459.993L170.702 454.252Z",
    fill: "#4D7AE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.348 452.291L163.714 449.724L166.509 454.765L165.996 452.805L167.348 452.291Z",
    fill: "#3366E0"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.509,
    y: 438.144,
    width: 42.1557,
    height: 17.5961,
    rx: 4,
    fill: "#FDD171"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.178,
    y: 445.182,
    width: 42.1557,
    height: 10.5577,
    rx: 4,
    fill: "#72767D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.509 463.259C205.509 461.05 207.3 459.259 209.509 459.259H370.132C372.341 459.259 374.132 461.05 374.132 463.259V472.855C374.132 475.064 372.341 476.855 370.132 476.855H205.509V463.259Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.509 476.855H346.028V490.451C346.028 492.66 344.237 494.451 342.028 494.451H209.509C207.3 494.451 205.509 492.66 205.509 490.451V476.855Z",
    fill: "#DCDDDE"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask7",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 508,
    width: 36,
    height: 36
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.892,
    cy: 526.124,
    rx: 17.5649,
    ry: 17.5961,
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 173.892,
    cy: 526.124,
    rx: 17.5649,
    ry: 17.5961,
    fill: "#FF82A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.821 512.65L183.769 512.8L183.616 513.167L183.564 513.317L183.445 513.584C180.819 519.705 175.785 524.217 172.45 527.354C168.996 530.587 165.109 533.322 160.901 535.481C156.757 537.473 154.884 535.685 155.348 532.292L155.763 530.588L157.809 522.003L157.896 521.586C159.28 515.991 161.413 512.778 168.345 511.041L178.894 508.445L178.928 508.429C182.611 507.537 185.174 508.778 183.821 512.65Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.737 508.477C179.391 509.036 173.124 513.071 166.908 518.996C160.692 524.921 155.941 531.46 155.513 534.669C156.099 536.381 157.899 536.913 160.902 535.481C165.11 533.322 168.996 530.587 172.45 527.355C175.786 524.218 180.82 519.706 183.445 513.585L183.565 513.319L183.616 513.168L183.77 512.802L183.821 512.651C184.626 510.382 184.086 509.023 182.737 508.477Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.802 525.143C178.834 519.409 182.839 513.825 181.746 512.671C180.653 511.517 174.877 515.231 168.844 520.965C162.811 526.7 158.807 532.284 159.9 533.438C160.993 534.592 166.769 530.878 172.802 525.143Z",
    fill: "#6B3143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.541 535.105L169.943 536.264C169.558 536.52 169.234 536.86 168.997 537.258C168.759 537.656 168.613 538.101 168.57 538.563L168.302 540.653L165.489 543.242C164.9 543.82 164.553 544.601 164.518 545.427L164.534 547.418C164.534 547.418 179.904 555.62 188.172 554.144C196.439 552.669 191.414 538.472 191.414 538.472C191.341 538.333 191.231 538.216 191.096 538.136C190.961 538.055 190.807 538.013 190.649 538.014L188.194 537.844L187.147 535.276C187.051 535.038 186.897 534.827 186.701 534.662C186.504 534.497 186.27 534.383 186.019 534.33L178.779 532.801L171.541 535.105Z",
    fill: "#EF6270"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.886 539.387C169.684 538.969 169.834 539.02 170.461 538.004C170.82 537.376 171.345 536.858 171.978 536.509L171.886 539.387Z",
    fill: "#BD3C53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.267 518.978C175.002 518.691 172.782 520.281 170.322 522.572C167.862 524.863 166.089 526.941 166.354 527.228C169.307 531.737 171.276 536.02 171.883 539.389L183.897 541.742C183.253 531.058 178.268 523.755 175.267 518.978Z",
    fill: "#FFB685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.831 528.476C179.731 528.097 179.439 527.846 179.179 527.915C178.92 527.984 178.791 528.348 178.892 528.727C178.993 529.106 179.285 529.358 179.544 529.289C179.803 529.22 179.932 528.856 179.831 528.476Z",
    fill: "#543247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.887 530.718C176.075 530.446 175.939 530.025 175.583 529.778C175.227 529.531 174.785 529.551 174.597 529.823C174.409 530.095 174.546 530.516 174.902 530.763C175.258 531.01 175.699 530.99 175.887 530.718Z",
    fill: "#543247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.36 534.42C179.367 533.925 180.29 533.431 180.724 533.551C181.157 533.672 180.966 534.473 180.491 535.373C180.015 536.273 180.152 535.873 179.052 535.58C177.952 535.287 177.588 534.799 178.36 534.42Z",
    fill: "#C74153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.779 534.255L178.006 534.802C178.037 535.12 178.485 535.441 179.052 535.58C179.619 535.718 180.27 535.773 180.491 535.373L180.695 534.94C180.413 534.703 179.633 534.128 178.779 534.255Z",
    fill: "#A82C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.306 533.548C179.633 533.78 178.982 534.072 178.36 534.419C177.924 534.633 177.955 534.868 178.154 535.104L180.468 534.051C180.603 533.985 180.438 533.733 180.306 533.548Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.222 530.407C183.239 530.357 183.206 530.289 183.224 530.239C183.184 529.9 183.04 529.582 182.812 529.328C182.584 529.074 182.282 528.898 181.949 528.824C182.03 528.896 182.093 528.986 182.134 529.086C182.175 529.186 182.192 529.295 182.185 529.403C182.178 529.511 182.146 529.616 182.091 529.71C182.037 529.804 181.963 529.884 181.873 529.944C181.55 530.13 181.189 530.236 180.818 530.254C180.334 530.309 179.869 530.469 179.454 530.723C179.039 530.977 178.684 531.319 178.416 531.725C176.712 531.645 176.118 532.728 174.91 533.321C174.584 533.49 174.234 533.606 173.871 533.664C172.683 533.872 172.487 533.386 172.459 532.733C171.147 533.793 171.969 535.306 172.985 535.682C173.584 535.971 174.387 535.826 175.228 535.164C177.313 535.682 178.05 535.403 179.253 533.438C181.237 533.922 182.514 533.128 182.613 531.289C182.78 531.204 182.923 531.079 183.03 530.925C183.136 530.771 183.202 530.593 183.222 530.407Z",
    fill: "#6B3143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.253 533.438C181.237 533.922 182.514 533.129 182.613 531.289C182.78 531.204 182.923 531.079 183.03 530.925C183.136 530.771 183.202 530.593 183.222 530.407C183.239 530.357 183.207 530.29 183.224 530.24C183.19 530.066 183.135 529.897 183.061 529.736C183.084 530.014 183.003 530.29 182.835 530.511C182.666 530.732 182.422 530.883 182.148 530.934C181.552 532.268 180.347 532.526 178.963 532.248C178.963 532.248 177.407 534.428 175.256 533.943C173.742 535.186 172.122 535.023 171.782 533.815C171.751 534.216 171.851 534.615 172.069 534.952C172.286 535.29 172.608 535.546 172.985 535.682C173.584 535.971 174.388 535.826 175.229 535.164C177.313 535.682 178.05 535.403 179.253 533.438Z",
    fill: "#5E2737"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.509,
    y: 508.528,
    width: 42.1557,
    height: 17.5961,
    rx: 4,
    fill: "#FFA78B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.178,
    y: 515.567,
    width: 42.1557,
    height: 10.5577,
    rx: 4,
    fill: "#72767D"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.509 533.643C205.509 531.434 207.3 529.643 209.509 529.643H393.509C395.718 529.643 397.509 531.434 397.509 533.643V545.643C397.509 547.853 395.718 549.643 393.509 549.643H209.509C207.3 549.643 205.509 547.853 205.509 545.643V533.643Z",
    fill: "#DCDDDE"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M207.515 30.4062C212.151 30.4062 215.91 26.6408 215.91 21.996C215.91 17.3511 212.151 13.5858 207.515 13.5858C202.878 13.5858 199.119 17.3511 199.119 21.996C199.119 26.6408 202.878 30.4062 207.515 30.4062Z",
    fill: "#1B1B26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.763 17.8987C230.763 15.874 229.125 14.2327 227.104 14.2327C225.083 14.2327 223.444 15.874 223.444 17.8987V25.9207C223.444 27.9454 225.083 29.5868 227.104 29.5868C229.125 29.5868 230.763 27.9454 230.763 25.9207V17.8987Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.049 160.657H436.341C437.311 160.657 438.242 161.043 438.928 161.731C439.614 162.418 440 163.351 440 164.323V201.199C440 202.171 439.614 203.104 438.928 203.791C438.242 204.479 437.311 204.865 436.341 204.865H435.049V160.657Z",
    fill: "#DE3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.049 249.288C436.362 249.288 437.621 249.811 438.55 250.741C439.478 251.671 440 252.933 440 254.248V328.646C440 329.962 439.478 331.223 438.55 332.154C437.621 333.084 436.362 333.606 435.049 333.606V249.288Z",
    fill: "#11111A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 161.573,
    y1: 135.241,
    x2: 167.341,
    y2: 133.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54B9C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 205.895,
    y1: 366.598,
    x2: 205.895,
    y2: 274.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7196FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A5EE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 218357,
    y1: 77475.6,
    x2: 218357,
    y2: 4667.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#537FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A5EE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 366408,
    y1: 55498.5,
    x2: 366408,
    y2: 3406.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#537FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A5EE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 69995.4,
    y1: 15121.1,
    x2: 69995.4,
    y2: 1094.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#537FF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A5EE8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 168.888,
    y1: 512.032,
    x2: 170.456,
    y2: 530.282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC285"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB8D6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 153.546,
    y1: 530.724,
    x2: 186.429,
    y2: 514.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D67569"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E39E7F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 440,
    height: 741.395,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.25 42.3124C135.25 37.8942 138.831 34.3124 143.25 34.3124H450.443C454.861 34.3124 458.443 37.8942 458.443 42.3124V539.24C458.443 543.658 454.861 547.24 450.443 547.24H143.25C138.831 547.24 135.25 543.658 135.25 539.24V42.3124Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.8243,
    height: 17.5961,
    fill: "white",
    transform: "translate(205.509 114.375)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.8243,
    height: 17.5961,
    fill: "white",
    transform: "translate(205.509 167.163)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.8243,
    height: 17.5961,
    fill: "white",
    transform: "translate(205.509 237.548)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.8243,
    height: 17.5961,
    fill: "white",
    transform: "translate(205.509 367.759)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.8243,
    height: 17.5961,
    fill: "white",
    transform: "translate(205.509 438.144)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 87.8243,
    height: 17.5961,
    fill: "white",
    transform: "translate(205.509 508.528)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelloImg1649933913062);
export default __webpack_public_path__ + "static/media/HelloIMG1649933913062.cc294c2a444b161831225b4873b48ec1.svg";
export { ForwardRef as ReactComponent };